/* eslint-disable */ //eslint意思是检查规范代码 
import layoutHeaderAside from '@/layout/header-aside'
import System from './modules/system';
import Ueditor from './modules/ueditor';
import Member from './modules/member';
import Archives from './modules/archives';
import customerService from './modules/customerService';
import Store from './modules/store';
import Order from './modules/order';
import stationManage from './modules/stationManage';
import Ads from './modules/ads';
import Activity from './modules/activity';
import Financial from './modules/financial';
import Upload from './modules/upload';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
	{
		path: '/',
		redirect: {
			name: 'index'
		},
		component: layoutHeaderAside,
		children: [
			// 首页
			{
				path: 'index',
				name: 'index',
				meta: {
					auth: true
				},
				component: _import('system/index')
			},

			// 系统 前端日志
			{
				path: 'log',
				name: 'log',
				meta: {
					title: '前端日志',
					auth: true
				},
				component: _import('system/log')
			},
			// 刷新页面 必须保留
			{
				path: 'refresh',
				name: 'refresh',
				hidden: true,
				component: _import('system/function/refresh')
			},
			// 页面重定向 必须保留
			{
				path: 'redirect/:route*',
				name: 'redirect',
				hidden: true,
				component: _import('system/function/redirect')
			}
		]
	},
	System,
	Ueditor,
	Member,
	Archives,
	customerService,
	Store,
	Order,
	stationManage,
	Ads,
	Activity,
	Financial,
	Upload
]

/**
 * 在主框架之外显示
 */
const frameOut = [
	// 登录
	{
		path: '/login',
		name: 'login',
		component: _import('system/login')
	},
	// 小程序调用
	{
		path: '/weixin',
		name: 'weixin',
		component: _import('weixin/getOpenId')
	}
]

/**
 * 错误页面
 */
const errorPage = [
	{
		path: '*',
		name: '404',
		component: _import('system/error/404')
	},
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
	...frameIn,
	...frameOut,
	...errorPage
]